/* RESPONSIBLE TEAM: team-workflows */
import type NotifySlackChannel from 'embercom/models/operator/visual-builder/step/notify-slack-channel';
import StepConfig, { type StepConfigParams } from '../step';

export default class NotifySlackChannelConfiguration extends StepConfig {
  declare step: NotifySlackChannel;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/notify-slack-channel',
      ...params,
    });
  }
}
